const ErrorIcon = (props) => (
  <svg width={19} height={19} viewBox="0 0 16 15" {...props}>
    <title>{'Validation/Error'}</title>
    <path
      d="M7.996.938c.736 0 1.392.363 1.76.982l5.968 9.998a1.888 1.888 0 010 1.965 2.033 2.033 0 01-1.76.983H2.036a2.016 2.016 0 01-1.76-.983 1.888 1.888 0 010-1.965l5.96-9.998a2.033 2.033 0 011.76-.982zm.615 11.198c-.387-.36-1.063-.36-1.45 0a.94.94 0 00-.304.7.9.9 0 00.303.686c.197.18.444.273.726.273.274 0 .528-.094.725-.273a.91.91 0 00.303-.687.94.94 0 00-.303-.7zm-.663-7.984h-.201l-.12.008a.883.883 0 00-.516.276.982.982 0 00-.254.687l.195 5.443.012.112c.067.403.393.706.78.706.428 0 .779-.36.792-.818l.2-5.437L8.833 5a.964.964 0 00-.242-.563.86.86 0 00-.642-.284z"
      fill="#B42A27"
      fillRule="nonzero"
    />
  </svg>
)

export default ErrorIcon
